import React from 'react';
import { Card, Container, Row, Col } from 'react-bootstrap';
import styled from 'styled-components';
import StyledText from '../StyledComponents/StyledText';
import { useTheme } from '../../middleware/ThemeContext';
import { Theme } from '../../utils/themes';
import ArrowIcon from '../../assets/icons/ArrowIcon';
import ChevronDownIcon from '../../assets/icons/ChevronDownIcon';

// TypeScript Interfaces
interface ContactSummaryData {
    fullName: string;
    emailAddress: string;
    primaryOrganization: string;
    contactRole: string;
}

interface OrganizationSummaryData {
    organizationName: string;
    organizationType: string;
    userRole: string;
    contactRole: string;
}

type SummaryType = 'contact_summary' | 'organization_summary';

interface SummaryCardProps {
    summaryType: SummaryType;
    contactData?: ContactSummaryData;
    organizationData?: OrganizationSummaryData;
    onProfileClick?: () => void;
    onManageOrganizationClick?: () => void;
}

// Styled Components
const SummaryCard = styled(Card) <{ theme: Theme }>`
  border: 1px solid ${({ theme }) => theme.CorporateTheme.colors.border};
  border-radius: 8px;
  max-width: 600px;
  margin: 20px auto;
  background-color: ${({ theme }) => theme.CorporateTheme.colors.background};
    padding: 16px 24px;

`;

const CardHeader = styled.div`
  border-bottom: 1px solid #e5e7eb;
  padding-bottom: 15px;
    text-align: left;
  
  h3 {
    margin: 0;
    font-size: 18px;
    font-weight: 600;
    color: #1f2937;
  }
`;

const CardBody = styled.div`
margin-top:20px;
text-align:left;
`;

const FieldRow = styled(Row)`
  margin-bottom: 16px;
  
  &:last-of-type {
    margin-bottom: 24px;
  }
`;

const FieldLabel = styled(Col)`
  font-weight: 500;
  color: #4b5563;
  font-size: 14px;
  padding-right: 8px;
  text-align: right;
  
  @media (max-width: 576px) {
    text-align: left;
    margin-bottom: 4px;
  }
`;

const FieldValue = styled(Col)`
  color: #374151;
  font-size: 14px;
  padding-left: 8px;
`;

const ActionButton = styled.button <{ theme: Theme }>`
  width: 100%;
  padding: 12px 24px;
  background-color: ${({ theme }) => theme.CorporateTheme.colors.headerBG};
  border:none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  transition: all 0.2s ease;
 
`;



// Main Component
const SummaryCardComponent: React.FC<SummaryCardProps> = ({
    summaryType,
    contactData,
    organizationData,
    onProfileClick,
    onManageOrganizationClick,
}) => {
    const { theme } = useTheme();
    const isContactSummary = summaryType === 'contact_summary';

    const getTitle = () => {
        return isContactSummary ? 'Contact Summary' : 'Organization Summary';
    };

    const getButtonConfig = () => {
        if (isContactSummary) {
            return {
                text: 'Go to My Profile',
                onClick: onProfileClick,
            };
        }
        return {
            text: 'Manage Organization',
            onClick: onManageOrganizationClick,
        };
    };

    const buttonConfig = getButtonConfig();

    return (
        <Container className='p-0'>
            <SummaryCard theme={theme}>
                <CardHeader>
                    <StyledText fontSize='13px' fontWeight={700} textColor={theme.CorporateTheme.colors.headerColor}>{getTitle()}</StyledText>
                </CardHeader>
                <CardBody>
                    {isContactSummary ? (
                        <div className='d-flex flex-column gap-3' style={{ textAlign: 'left', alignItems: 'flex-start' }}>
                            <StyledText fontSize='12px' fontWeight={600} textColor={theme.CorporateTheme.colors.headerColor}>
                                Full Name:
                            </StyledText>


                            <StyledText fontSize='12px' fontWeight={600} textColor={theme.CorporateTheme.colors.headerColor}>
                                Email Address:
                            </StyledText>

                            <StyledText fontSize='12px' fontWeight={600} textColor={theme.CorporateTheme.colors.headerColor}>
                                Primary Organization:
                            </StyledText>

                            <StyledText fontSize='12px' fontWeight={600} textColor={theme.CorporateTheme.colors.headerColor}>
                                Contact Role:
                            </StyledText>
                        </div>
                    ) : (
                        <div className='d-flex flex-column gap-3' style={{ textAlign: 'left', alignItems: 'flex-start' }}>
                            <StyledText fontSize='12px' fontWeight={600} textColor={theme.CorporateTheme.colors.headerColor}>
                                Organization Name:
                            </StyledText>

                            {/* <StyledText fontSize='12px' fontWeight={600} textColor={theme.CorporateTheme.colors.headerColor}>
                                Organization Type :
                            </StyledText>

                            <StyledText fontSize='12px' fontWeight={600} textColor={theme.CorporateTheme.colors.headerColor}>
                                User Role :
                            </StyledText> */}

                            <StyledText fontSize='12px' fontWeight={600} textColor={theme.CorporateTheme.colors.headerColor}>
                                Contact Role:
                            </StyledText>
                        </div>
                    )}

                    <ActionButton className="mt-4" theme={theme}>
                        <StyledText fontSize='12px' fontWeight={500} textColor={theme.CorporateTheme.colors.headerColor}>{buttonConfig.text}</StyledText>
                        <ChevronDownIcon color={theme.CorporateTheme.colors.headerColor} size={14} rotate='left' />
                    </ActionButton>
                </CardBody>
            </SummaryCard>
        </Container>
    );
};

export default SummaryCardComponent;